// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4OP3EY2bx{display:flex}._4OP3EY2bx ._7jQuqTVjx{min-width:0}._7jQuqTVjx{padding:6px}._7jQuqTVjx:not(._4iytDV1xx) path{fill:rgba(0,0,0,0.59)}@media screen and (-ms-high-contrast: active){._7jQuqTVjx:not(._4iytDV1xx) path{fill:buttonText}}._7jQuqTVjx:not(._3ViMilwLx):not(._6sOv60Xzx){border-radius:0}._3ViMilwLx{border-top-right-radius:0;border-bottom-right-radius:0}._6sOv60Xzx{border-top-left-radius:0;border-bottom-left-radius:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"toggle-buttons": "_4OP3EY2bx",
	"toggleButtons": "_4OP3EY2bx",
	"toggle-button": "_7jQuqTVjx",
	"toggleButton": "_7jQuqTVjx",
	"selected": "_4iytDV1xx",
	"first": "_3ViMilwLx",
	"last": "_6sOv60Xzx"
};
module.exports = exports;
